module.exports = __webpack_public_path__ + "static/media/print-1.abbb6de5.jpg";